export const validate = (values: any) => {
  const errors: any = {};

  if (!values.fullName) {
    errors.fullName = '*Name is required';
  }

  if (!values.adId) {
    errors.adId = '*Actice Directory ID is required';
  }

  if (!values.email) {
    errors.email = '*Email is required';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = '*Invalid email address';
  }

  if (!values.departmentId) {
    errors.caseTypeId = '*Please select a department';
  }

  if (!values.roleId) {
    errors.roleId = '*Please select a role';
  }

  return errors;
};
